import react, { useState, useEffect } from 'react'
import Container from "./styled";
import Marcador from "../marcador/index";
import DropdownItem from "./dropDown";
import { Fade } from "react-awesome-reveal";
import { BsCheckLg } from "react-icons/bs";
import { Link } from "react-scroll";
import IkeModalSwitch from "./ikeModal/switch";
import { useLocation } from 'react-router-dom'

export default function Elegi({ nextStep, updateIds, planSelected }) {

    const { state } = useLocation();
    const [isQuestionOpen, setIsQuestionOpen] = useState({
        isActiveUno: false,
        isActiveDos: false,
        isActiveTres: false,
        isActiveCuatro: false,
        isActiveCinco: false,
        isActiveSeis: false,
        isActiveSiete: false,
        isActiveOcho: false,
        isActiveNueve: false,
        isActiveDiez: false,
        isOpen: false,
    })
    console.log("PÁGINA DE PASOS")
    console.log(state)
  
    useEffect(() => {
      if(state.id_cotizacion && state.id_contrata){
        updateIds(state.id_contrata, state.id_cotizacion)
      }
    }, [state])

    ///////////////////////////////////////

    // Toggle pora cambiar el estado que determina si el pop-up esta abierto o no
    const togglePopup = () => {
        setIsQuestionOpen((prev) => ({ ...prev, ["isOpen"]: !isQuestionOpen.isOpen }));
    };

    useEffect(() => {
        setTimeout(() => {
            togglePopup();
        }, 2000);
    }, [])

    // Toggle para cambiar el estado cuando se abre o se cierra cada una de las questions
    const handleToggleUno = () => {
        setIsQuestionOpen((prev) => ({ ...prev, ["isActiveUno"]: !isQuestionOpen.isActiveUno }));
        setIsQuestionOpen((prev) => ({ ...prev, ["isActiveDos"]: false }));
        setIsQuestionOpen((prev) => ({ ...prev, ["isActiveTres"]: false }));
        setIsQuestionOpen((prev) => ({ ...prev, ["isActiveCuatro"]: false }));
        setIsQuestionOpen((prev) => ({ ...prev, ["isActiveCinco"]: false }));
    };

    const handleToggleDos = () => {
        setIsQuestionOpen((prev) => ({ ...prev, ["isActiveUno"]: false }));
        setIsQuestionOpen((prev) => ({ ...prev, ["isActiveDos"]: !isQuestionOpen.isActiveDos }));
        setIsQuestionOpen((prev) => ({ ...prev, ["isActiveTres"]: false }));
        setIsQuestionOpen((prev) => ({ ...prev, ["isActiveCuatro"]: false }));
        setIsQuestionOpen((prev) => ({ ...prev, ["isActiveCinco"]: false }));
    };

    const handleToggleTres = () => {
        setIsQuestionOpen((prev) => ({ ...prev, ["isActiveUno"]: false }));
        setIsQuestionOpen((prev) => ({ ...prev, ["isActiveDos"]: false }));
        setIsQuestionOpen((prev) => ({ ...prev, ["isActiveTres"]: !isQuestionOpen.isActiveTres }));
        setIsQuestionOpen((prev) => ({ ...prev, ["isActiveCuatro"]: false }));
        setIsQuestionOpen((prev) => ({ ...prev, ["isActiveCinco"]: false }));
    };

    const handleToggleCuatro = () => {
        setIsQuestionOpen((prev) => ({ ...prev, ["isActiveUno"]: false }));
        setIsQuestionOpen((prev) => ({ ...prev, ["isActiveDos"]: false }));
        setIsQuestionOpen((prev) => ({ ...prev, ["isActiveTres"]: false }));
        setIsQuestionOpen((prev) => ({ ...prev, ["isActiveCuatro"]: !isQuestionOpen.isActiveCuatro }));
        setIsQuestionOpen((prev) => ({ ...prev, ["isActiveCinco"]: false }));
    };

    const handleToggleCinco = () => {
        setIsQuestionOpen((prev) => ({ ...prev, ["isActiveUno"]: false }));
        setIsQuestionOpen((prev) => ({ ...prev, ["isActiveDos"]: false }));
        setIsQuestionOpen((prev) => ({ ...prev, ["isActiveTres"]: false }));
        setIsQuestionOpen((prev) => ({ ...prev, ["isActiveCuatro"]: false }));
        setIsQuestionOpen((prev) => ({ ...prev, ["isActiveCinco"]: !isQuestionOpen.isActiveCinco }));
    };

    const Continue = (e, plan) => {
        e.preventDefault();
        // Setear info del plan seleccionado para completar en el próximo paso
        let planData = {}
        switch(plan){
            case "Prudencia Gold":
                planData = {
                    seguro:"Prudencia Seguros",
                    // Logo del seguro
                    logo:"images/logos/prudenciaseguros.png",
                    // Nombre del plan
                    plan:"Plan Gold",
                    planSelected:{planSelected},
                    // Checks
                    resCivil:"si",
                    roboTotal:"si",
                    roboParcial:"si",
                    desTotal:"si",
                    asistencia:"si",
                    competencias:"no",
                    // Precios
                    cuotas:`${state.precios.prudencia.cuotas} cuotas`,
                    precioAnterior:`$${state.precios.prudencia.gold}`,
                    oferta:state.precios.prudencia_off.off,
                    precio:`$${state.precios.prudencia_off.gold}`,
                    contratando:"Contratando Online"
                }
                break
            case "Prudencia Platinum":
                planData = {
                    seguro:"Prudencia Seguros",
                    // Logo del seguro
                    logo:"images/logos/prudenciaseguros.png",
                    // Nombre del plan
                    plan:"Plan Platinum",
                    planSelected:{planSelected},
                    // Checks
                    resCivil:"si",
                    roboTotal:"si",
                    roboParcial:"si",
                    desTotal:"si",
                    asistencia:"si",
                    competencias:"si",
                    // Precios
                    cuotas:`${state.precios.prudencia.cuotas} cuotas`,
                    precioAnterior:`$${state.precios.prudencia.platinum}`,
                    oferta:state.precios.prudencia_off.off,
                    precio:`$${state.precios.prudencia_off.platinum}`,
                    contratando:"Contratando Online"
                }
                break
            case "Segunda Standard":
                planData = {
                    seguro:"La Segunda",
                    // Logo del seguro
                    logo:"images/logos/lasegunda.png",
                    // Nombre del plan
                    plan:"Plan Standard",
                    planSelected:{planSelected},
                    // Checks
                    resCivil:"si",
                    roboTotal:"si",
                    roboParcial:"no",
                    desTotal:"no",
                    asistencia:"si",
                    competencias:"no",
                    // Precios
                    cuotas:`10 cuotas`,
                    precioAnterior:"",
                    oferta:"",
                    precio:`$${state.precios.segunda_off.standard}`,
                    contratando:""
                }
                break
            case "Segunda Gold":
                planData = {
                    seguro:"La Segunda",
                    // Logo del seguro
                    logo:"images/logos/lasegunda.png",
                    // Nombre del plan
                    plan:"Plan Gold",
                    planSelected:{planSelected},
                    // Checks
                    resCivil:"si",
                    roboTotal:"si",
                    roboParcial:"no",
                    desTotal:"si",
                    asistencia:"si",
                    competencias:"no",
                    // Precios
                    cuotas:`10 cuotas`,
                    precioAnterior:"",
                    oferta:"",
                    precio:`$${state.precios.segunda_off.gold}`,
                    contratando:""
                }
                break
            case "Federación Patronal Platinum":
                planData = {
                    seguro:"Federación Patronal Seguros",
                    // Logo del seguro
                    logo:"images/logos/federacionpatronalseguros.png",
                    // Nombre del plan
                    plan:"Plan Platinum",
                    planSelected:{planSelected},
                    // Checks
                    resCivil:"si",
                    roboTotal:"si",
                    roboParcial:"no",
                    desTotal:"si",
                    asistencia:"si",
                    competencias:"no",
                    // Precios
                    cuotas:state.precios.fed.platinum,
                    precioAnterior:"",
                    oferta:"",
                    precio:state.precios.fed_off.platinum,
                    contratando:""
                }
                break
        }
        planSelected(planData)
        nextStep()
    };

    return (
      <Container>
        {/* Marcador */}
        <Marcador pasoDos="activo" background="red"></Marcador>
        {/* Referencias */}
        <div className="segurosContainer topInOpacity5">
          <div className="conditionsContainer">
            <p>Responsabilidad Civil</p>
            <p>Robo Total</p>
            <p>Robo Parcial</p>
            <p>Destrucción Total</p>
            <p>Asistencia</p>
            <p>Competencias</p>
            <p id="cuotasMensuales">
              Cuotas
              <br />
              Mensuales
            </p>
          </div>
          {/* Opcion 1 */}
          {state.precios.valor < 150000 ? 
          <Fade
            delay={100}
            duration={600}
            triggerOnce={true}
            className="dropDownContainer"
          >
            <DropdownItem
              // Functions
              clickFunction={handleToggleUno}
              isActive={isQuestionOpen.isActiveUno}
              nextStep={nextStep}
              // Seguro
              seguro="Prudencia Seguros"
              // Logo del seguro
              logo="images/logos/prudenciaseguros.png"
              // Nombre del plan
              plan="Plan Gold"
              planSelected={planSelected}
              // Checks
              resCivil="si"
              roboTotal="si"
              roboParcial="si"
              desTotal="si"
              asistencia="si"
              competencias="no"
              // Precios
              cuotas={`${state.precios.prudencia.cuotas} cuotas`}
              precioAnterior={`$${state.precios.prudencia.gold}`}
              oferta={state.precios.prudencia_off.off}
              precio={`$${state.precios.prudencia_off.gold}`}
              contratando="Contratando Online"
            >
              <div className="panelContainer">
                <div className="panelPlanSeguro topInOpacity5">
                  <p>Prudencia Seguros</p>
                  <p>-</p>
                  <p>Plan Gold</p>
                </div>
                <div className="dataPanelContainer">
                  {/* Detalles Container */}
                  <div className="detallesContainer topInOpacity6">
                    <h4>Detalles de cobertura</h4>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Responsabilidad Civil hasta $200.000</p>
                    </div>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Robo Total en Vía Pública y Hogar, Franquicia 10%*</p>
                    </div>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Robo Parcial, Sin Franquicia</p>
                    </div>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Destrucción Total por accidente e incendio, Franquicia
                        10%*
                      </p>
                    </div>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Asistencia Básica: Reembolso de gastos de traslado por
                        averías
                      </p>
                    </div>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Extensión de cobertura a países limítrofes</p>
                    </div>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Para proteger tu bicicleta, cada cuatro meses se aumenta
                        aprox. un 16% la suma asegurada
                      </p>
                    </div>
                  </div>
                  {/* Beneficios Container */}
                  <div className="beneficiosContainer topInOpacity6">
                    <h4>Beneficios de la cobertura</h4>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Traslado por avería de Bicicleta hasta 50 km y
                        Asistencia por rotura de neumático
                      </p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Asistencia por Rotura de Neumático</p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Reintegro de medicamentos como consecuencia de robo o su
                        intento
                      </p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Envío de taxi para su traslado a domicilio por robo</p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Envió de ambulancia hasta el Centro medico más cercano
                      </p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Primera consulta médica</p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Conexión con centros por reparación de bicicleta</p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Denuncia y bloqueo de celulares y tarjetas de crédito
                      </p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Cambio de Cerraduras por robo</p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Reembolso de gastos de DNI por robo</p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Asesoramiento legal ante el Robo o Accidente</p>
                    </div>
                  </div>
                </div>
                <div className="panelVigenciaButton topInOpacity7">
                  <p>
                    *La Franquicia no tiene validez si repones la Bicicleta en
                    Bicicleterías adheridas
                  </p>
                  <p>Vigencia Anual - 12 cuotas mensuales de: $102,83</p>
                  <Link onClick={ (e) => Continue(e, "Prudencia Gold") } to="header" spy={true}>
                    Contratá ahora
                  </Link>
                </div>
              </div>
            </DropdownItem>
          </Fade>
          : null}
          {/* Opcion 2 */}
          {state.precios.valor < 100000 ? 
          <Fade
            delay={100}
            duration={600}
            triggerOnce={true}
            className="dropDownContainer"
          >
            <DropdownItem
              // Functions
              clickFunction={handleToggleDos}
              isActive={isQuestionOpen.isActiveDos}
              nextStep={nextStep}
              // Seguro
              seguro="La Segunda"
              // Logo del seguro
              logo="images/logos/lasegunda.png"
              // Nombre del plan
              plan="Plan Standard"
              planSelected={planSelected}
              // Checks
              resCivil="si"
              roboTotal="si"
              roboParcial="no"
              desTotal="no"
              asistencia="si"
              competencias="no"
              // Precios
              cuotas="10 cuotas"
              precioAnterior=""
              oferta=""
              precio={`$${state.precios.segunda_off.standard}`}
              contratando=""
            >
              <div className="panelContainer">
                <div className="panelPlanSeguro topInOpacity5">
                  <p>La Segunda</p>
                  <p>-</p>
                  <p>Plan Standar</p>
                </div>
                <div className="dataPanelContainer">
                  {/* Detalles Container */}
                  <div className="detallesContainer topInOpacity6">
                    <h4>Detalles de cobertura</h4>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Responsabilidad Civil hasta $200.000</p>
                    </div>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Robo Total en Vía Pública y Hogar, Franquicia 10%*</p>
                    </div>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Robo Parcial, Sin Franquicia</p>
                    </div>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Destrucción Total por accidente e incendio, Franquicia
                        10%*
                      </p>
                    </div>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Asistencia Básica: Reembolso de gastos de traslado por
                        averías
                      </p>
                    </div>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Extensión de cobertura a países limítrofes</p>
                    </div>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Para proteger tu bicicleta, cada cuatro meses se aumenta
                        aprox. un 16% la suma asegurada
                      </p>
                    </div>
                  </div>
                  {/* Beneficios Container */}
                  <div className="beneficiosContainer topInOpacity6">
                    <h4>Beneficios de la cobertura</h4>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Traslado por avería de Bicicleta hasta 50 km y
                        Asistencia por rotura de neumático
                      </p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Asistencia por Rotura de Neumático</p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Reintegro de medicamentos como consecuencia de robo o su
                        intento
                      </p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Envío de taxi para su traslado a domicilio por robo</p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Envió de ambulancia hasta el Centro medico más cercano
                      </p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Primera consulta médica</p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Conexión con centros por reparación de bicicleta</p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Denuncia y bloqueo de celulares y tarjetas de crédito
                      </p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Cambio de Cerraduras por robo</p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Reembolso de gastos de DNI por robo</p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Asesoramiento legal ante el Robo o Accidente</p>
                    </div>
                  </div>
                </div>
                <div className="panelVigenciaButton topInOpacity7">
                  <p>
                    *La Franquicia no tiene validez si repones la Bicicleta en
                    Bicicleterías adheridas
                  </p>
                  <p>Vigencia Anual - 12 cuotas mensuales de: $102,83</p>
                  <Link onClick={ (e) => Continue(e, "Segunda Standard") } to="header" spy={true}>
                    Contratá ahora
                  </Link>
                </div>
              </div>
            </DropdownItem>
          </Fade>
          : null}
          {/* Opcion 3 */}
          {state.precios.valor < 100000 ? 
          <Fade
            delay={100}
            duration={600}
            triggerOnce={true}
            className="dropDownContainer"
          >
            <DropdownItem
              // Functions
              clickFunction={handleToggleTres}
              isActive={isQuestionOpen.isActiveTres}
              nextStep={nextStep}
              // Seguro
              seguro="La Segunda"
              // Logo del seguro
              logo="images/logos/lasegunda.png"
              // Nombre del plan
              plan="Plan Gold"
              planSelected={planSelected}
              // Checks
              resCivil="si"
              roboTotal="si"
              roboParcial="no"
              desTotal="si"
              asistencia="si"
              competencias="no"
              // Precios
              cuotas="10 cuotas"
              precioAnterior=""
              oferta=""
              precio={`$${state.precios.segunda_off.gold}`}
              contratando=""
            >
              <div className="panelContainer">
                <div className="panelPlanSeguro topInOpacity5">
                  <p>La Segunda</p>
                  <p>-</p>
                  <p>Plan Gold</p>
                </div>
                <div className="dataPanelContainer">
                  {/* Detalles Container */}
                  <div className="detallesContainer topInOpacity6">
                    <h4>Detalles de cobertura</h4>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Responsabilidad Civil hasta $200.000</p>
                    </div>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Robo Total en Vía Pública y Hogar, Franquicia 10%*</p>
                    </div>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Robo Parcial, Sin Franquicia</p>
                    </div>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Destrucción Total por accidente e incendio, Franquicia
                        10%*
                      </p>
                    </div>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Asistencia Básica: Reembolso de gastos de traslado por
                        averías
                      </p>
                    </div>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Extensión de cobertura a países limítrofes</p>
                    </div>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Para proteger tu bicicleta, cada cuatro meses se aumenta
                        aprox. un 16% la suma asegurada
                      </p>
                    </div>
                  </div>
                  {/* Beneficios Container */}
                  <div className="beneficiosContainer topInOpacity6">
                    <h4>Beneficios de la cobertura</h4>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Traslado por avería de Bicicleta hasta 50 km y
                        Asistencia por rotura de neumático
                      </p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Asistencia por Rotura de Neumático</p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Reintegro de medicamentos como consecuencia de robo o su
                        intento
                      </p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Envío de taxi para su traslado a domicilio por robo</p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Envió de ambulancia hasta el Centro medico más cercano
                      </p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Primera consulta médica</p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Conexión con centros por reparación de bicicleta</p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Denuncia y bloqueo de celulares y tarjetas de crédito
                      </p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Cambio de Cerraduras por robo</p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Reembolso de gastos de DNI por robo</p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Asesoramiento legal ante el Robo o Accidente</p>
                    </div>
                  </div>
                </div>
                <div className="panelVigenciaButton topInOpacity7">
                  <p>
                    *La Franquicia no tiene validez si repones la Bicicleta en
                    Bicicleterías adheridas
                  </p>
                  <p>Vigencia Anual - 12 cuotas mensuales de: $102,83</p>
                  <Link onClick={ (e) => Continue(e, "Segunda Gold") } to="header" spy={true}>
                    Contratá ahora
                  </Link>
                </div>
              </div>
            </DropdownItem>
          </Fade>
          : null}
          {/* Opcion 4 */}
          {state.precios.valor < 150000 ?
          <Fade
            delay={100}
            duration={600}
            triggerOnce={true}
            className="dropDownContainer"
          >
            <DropdownItem
              // Functions
              clickFunction={handleToggleCuatro}
              isActive={isQuestionOpen.isActiveCuatro}
              nextStep={nextStep}
              // Seguro
              seguro="Prudencia Seguros"
              // Logo del seguro
              logo="images/logos/prudenciaseguros.png"
              // Nombre del plan
              plan="Plan Platinum"
              planSelected={planSelected}
              // Checks
              resCivil="si"
              roboTotal="si"
              roboParcial="si"
              desTotal="si"
              asistencia="si"
              competencias="si"
              // Precios
              cuotas={`${state.precios.prudencia.cuotas} cuotas`}
              precioAnterior={`$${state.precios.prudencia.platinum}`}
              oferta={state.precios.prudencia_off.off}
              precio={`$${state.precios.prudencia_off.platinum}`}
              contratando="Contratando Online"
            >
              <div className="panelContainer">
                <div className="panelPlanSeguro topInOpacity5">
                  <p>Prudencia Seguros</p>
                  <p>-</p>
                  <p>Plan Platinum</p>
                </div>
                <div className="dataPanelContainer">
                  {/* Detalles Container */}
                  <div className="detallesContainer topInOpacity6">
                    <h4>Detalles de cobertura</h4>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Responsabilidad Civil hasta $200.000</p>
                    </div>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Robo Total en Vía Pública y Hogar, Franquicia 10%*</p>
                    </div>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Robo Parcial, Sin Franquicia</p>
                    </div>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Destrucción Total por accidente e incendio, Franquicia
                        10%*
                      </p>
                    </div>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Asistencia Básica: Reembolso de gastos de traslado por
                        averías
                      </p>
                    </div>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Extensión de cobertura a países limítrofes</p>
                    </div>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Para proteger tu bicicleta, cada cuatro meses se aumenta
                        aprox. un 16% la suma asegurada
                      </p>
                    </div>
                  </div>
                  {/* Beneficios Container */}
                  <div className="beneficiosContainer topInOpacity6">
                    <h4>Beneficios de la cobertura</h4>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Traslado por avería de Bicicleta hasta 50 km y
                        Asistencia por rotura de neumático
                      </p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Asistencia por Rotura de Neumático</p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Reintegro de medicamentos como consecuencia de robo o su
                        intento
                      </p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Envío de taxi para su traslado a domicilio por robo</p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Envió de ambulancia hasta el Centro medico más cercano
                      </p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Primera consulta médica</p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Conexión con centros por reparación de bicicleta</p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Denuncia y bloqueo de celulares y tarjetas de crédito
                      </p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Cambio de Cerraduras por robo</p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Reembolso de gastos de DNI por robo</p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Asesoramiento legal ante el Robo o Accidente</p>
                    </div>
                  </div>
                </div>
                <div className="panelVigenciaButton topInOpacity7">
                  <p>
                    *La Franquicia no tiene validez si repones la Bicicleta en
                    Bicicleterías adheridas
                  </p>
                  <p>Vigencia Anual - 12 cuotas mensuales de: $102,83</p>
                  <Link onClick={ (e) => Continue(e, "Prudencia Platinum") } to="header" spy={true}>
                    Contratá ahora
                  </Link>
                </div>
              </div>
            </DropdownItem>
          </Fade>
          : null}
          {/* Opcion 5 */}
          <Fade
            delay={100}
            duration={600}
            triggerOnce={true}
            className="dropDownContainer"
          >
            <DropdownItem
              // Functions
              clickFunction={handleToggleCinco}
              isActive={isQuestionOpen.isActiveCinco}
              nextStep={nextStep}
              // Seguro
              seguro="Federación Patronal Seguros"
              // Logo del seguro
              logo="images/logos/federacionpatronalseguros.png"
              // Nombre del plan
              plan="Plan Platinum"
              planSelected={planSelected}
              // Checks
              resCivil="si"
              roboTotal="si"
              roboParcial="no"
              desTotal="si"
              asistencia="si"
              competencias="no"
              // Precios
              cuotas={`${state.precios.fed.platinum}`}
              precioAnterior=""
              oferta=""
              precio={state.precios.fed_off.platinum}
              contratando=""
            >
              <div className="panelContainer">
                <div className="panelPlanSeguro topInOpacity5">
                  <p>Federación Patronal</p>
                  <p>-</p>
                  <p>Plan Gold</p>
                </div>
                <div className="dataPanelContainer">
                  {/* Detalles Container */}
                  <div className="detallesContainer topInOpacity6">
                    <h4>Detalles de cobertura</h4>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Responsabilidad Civil hasta $200.000</p>
                    </div>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Robo Total en Vía Pública y Hogar, Franquicia 10%*</p>
                    </div>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Robo Parcial, Sin Franquicia</p>
                    </div>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Destrucción Total por accidente e incendio, Franquicia
                        10%*
                      </p>
                    </div>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Asistencia Básica: Reembolso de gastos de traslado por
                        averías
                      </p>
                    </div>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Extensión de cobertura a países limítrofes</p>
                    </div>
                    {/* Detalle */}
                    <div className="detalle">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Para proteger tu bicicleta, cada cuatro meses se aumenta
                        aprox. un 16% la suma asegurada
                      </p>
                    </div>
                  </div>
                  {/* Beneficios Container */}
                  <div className="beneficiosContainer topInOpacity6">
                    <h4>Beneficios de la cobertura</h4>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Traslado por avería de Bicicleta hasta 50 km y
                        Asistencia por rotura de neumático
                      </p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Asistencia por Rotura de Neumático</p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Reintegro de medicamentos como consecuencia de robo o su
                        intento
                      </p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Envío de taxi para su traslado a domicilio por robo</p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Envió de ambulancia hasta el Centro medico más cercano
                      </p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Primera consulta médica</p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Conexión con centros por reparación de bicicleta</p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>
                        Denuncia y bloqueo de celulares y tarjetas de crédito
                      </p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Cambio de Cerraduras por robo</p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Reembolso de gastos de DNI por robo</p>
                    </div>
                    {/* Beneficio */}
                    <div className="beneficio">
                      <span>
                        <BsCheckLg />
                      </span>
                      <p>Asesoramiento legal ante el Robo o Accidente</p>
                    </div>
                  </div>
                </div>
                <div className="panelVigenciaButton topInOpacity7">
                  <p>
                    *La Franquicia no tiene validez si repones la Bicicleta en
                    Bicicleterías adheridas
                  </p>
                  <p>Vigencia Anual - 12 cuotas mensuales de: $102,83</p>
                  <Link onClick={ (e) => Continue(e, "Federación Patronal Platinum") } to="header" spy={true}>
                    Contratá ahora
                  </Link>
                </div>
              </div>
            </DropdownItem>
          </Fade>
        </div>
        {isQuestionOpen.isOpen && <IkeModalSwitch handleClose={togglePopup} />}
      </Container>
    );
}
